import { Box, Button, Modal, Typography } from "@mui/material";
import HistoryIcon from '@mui/icons-material/History';
import { useState, useEffect } from "react";
import styled from "styled-components";
import HistoryLoad from './../features/HistoryLoad';
import axios from "axios";
import CloseIcon from '@mui/icons-material/Close';
const StyledModal = styled(Modal)({
    display:"flex",
    alignItems:"center",
    justifyContent:"center"
})


const config = {
    headers: {
        "Access-Control-Allow-Origin": "*",
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,PUT,POST,OPTIONS,ANY",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Headers": "Origin, Content-Type, Accept, Authorization, X-Requested-With, privatekey"
    }
};
const Historybutton = (data) => {
    const [open, setOpen] = useState(false);
    const [responsedata, setResponeData] = useState(data.data);
    const [isOpen, setIsOpen] = useState(false);
    useEffect(() => {
        setIsOpen(true)
        }, []);
    return(
        <>
            <Button onClick={(e)=>setOpen(true)} sx={{width:18, color: '#fff', alignItems:'center', minWidth:'25px !important' }} startIcon={<HistoryIcon sx={{color:'#bf360c', marginLeft:1}}/>}/>
            <StyledModal open={open} onClose={(e)=>setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description">
                <Box style={{width:"85%", height:"85%", "padding": "3px !important"}} bgcolor={"background.default"} color={"text.primary"} 
                    p={3} borderRadius={3}>
                    <Box borderRadius={2} sx={{ height: 40, bgcolor: "success.main" }}>
                        <Box p={1} display={"flex"} sx={{ alignContent: "center", justifyContent: "space-between" }}>
                            <Typography varient="h6" color="white" textAlign={"left"} sx={{ marginLeft: 1 }}>{'Conversion History'} </Typography>
                            <Button onClick={(e) => setOpen(false)} sx={{ marginLeft: 10, alignContent: 'center' }} startIcon={<CloseIcon sx={{ color: "white", alignContent: "center", marginLeft: 2 }} />} />
                        </Box>
                    </Box>
                    {isOpen && 
                     <HistoryLoad data={data.data}></HistoryLoad>
                    }
                </Box>
            </StyledModal>
        </>
    )
}

export default Historybutton;